import { render, staticRenderFns } from "./InputCourseForm.vue?vue&type=template&id=23e63cf1&scoped=true&"
import script from "./InputCourseForm.vue?vue&type=script&lang=js&"
export * from "./InputCourseForm.vue?vue&type=script&lang=js&"
import style0 from "./InputCourseForm.vue?vue&type=style&index=0&id=23e63cf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e63cf1",
  null
  
)

export default component.exports